// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageUK = {
  seo: {
    title: 'Прозорість у сфері ШІ | pAIoneer Labs GmbH',
    description: 'Як pAIoneer Labs GmbH використовує штучний інтелект та інформує про це: ШІ-асистент, маркування контенту, згенерованого ШІ, редакційна відповідальність і контактна особа відповідно до Регламенту про ШІ.',
    keywords: 'прозорість у сфері ШІ, Регламент про ШІ, AI Act, ст.\u00a050, маркування, ШІ-асистент, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Прозорість у сфері ШІ',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'Прозорість у сфері ШІ',
    subtitle: 'Як pAIoneer Labs GmbH використовує штучний інтелект та інформує про це.'
  },
  sections: [
    {
      title: 'Правові рамки',
      paragraphs: [
        'З 2 серпня 2026 року застосовуються обов’язки щодо прозорості відповідно до ст.\u00a050 Регламенту (ЄС) 2024/1689 про штучний інтелект (Регламент про ШІ). У Німеччині згідно з KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, німецький Закон про ринковий нагляд у сфері ШІ та сприяння інноваціям) Bundesnetzagentur (Федеральне мережеве агентство Німеччини) є органом ринкового нагляду та органом розгляду скарг щодо Регламенту про ШІ.',
        'На цій сторінці описано, які системи ШІ використовує pAIoneer Labs GmbH і як вона інформує про них. Як при цьому обробляються персональні дані, описано в політиці конфіденційності.'
      ]
    },
    {
      title: 'ШІ-асистент у нашому застосунку',
      paragraphs: [
        'У нашому застосунку на ваші запитання відповідає ШІ-асистент. Він є системою ШІ: його відповіді автоматично генеруються мовними моделями й можуть бути помилковими. Перевіряйте важливі відомості, перш ніж ухвалювати на їх основі рішення.',
        'Застосунок повідомляє про це перед вашим першим введенням і постійно поруч із чатом (ст.\u00a050\u2060(1) Регламенту про ШІ). Крім того, кожну відповідь асистента позначено в машинозчитуваному форматі як згенеровану ШІ (ст.\u00a050\u2060(2) Регламенту про ШІ).',
        'Мовні моделі надаються через сервіс OpenRouter, Inc., США.'
      ]
    },
    {
      title: 'Безпосередня комунікація із системами ШІ',
      paragraphs: [
        'Якщо система ШІ pAIoneer Labs GmbH безпосередньо спілкується з вами, наприклад у чаті, вона повідомляє, що є системою ШІ, не пізніше ніж під час першої взаємодії.'
      ]
    },
    {
      title: 'Вміст цього вебсайту',
      paragraphs: [
        'Тексти цього вебсайту – також там, де в їх створенні допомагають інструменти ШІ, – перевіряє pAIoneer Labs GmbH і публікує під своєю редакційною відповідальністю (ст.\u00a050\u2060(4), другий абзац, Регламенту про ШІ).',
        'Зображення, аудіо- чи відеоконтент, створений або змінений за допомогою ШІ, який оманливо реалістично зображує реальних осіб, місця чи події, ми позначаємо як штучно створений або змінений (ст.\u00a050\u2060(4), перший абзац, Регламенту про ШІ).'
      ]
    },
    {
      title: 'Аналіз за допомогою машинного навчання',
      paragraphs: [
        'За вашою згодою ми аналізуємо статистику відвідувань методами машинного навчання; подробиці наведено в політиці конфіденційності. При цьому ми не застосовуємо ні розпізнавання емоцій, ні біометричної категоризації (ст.\u00a050\u2060(3) Регламенту про ШІ). Розрізнення між людьми та автоматизованими зверненнями ґрунтується на технічних характеристиках пристрою, браузера та з’єднання, а не на біометричних даних.'
      ]
    },
    {
      title: 'Скарга',
      paragraphs: [
        'Зі скаргою щодо можливого порушення Регламенту про ШІ ви можете звернутися до Bundesnetzagentur – органу ринкового нагляду та органу розгляду скарг щодо Регламенту про ШІ в Німеччині. Інформацію про це агентство надає на сторінці bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Контакт',
    description: 'З питань щодо використання штучного інтелекту ви можете звернутися до нас електронною поштою.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Станом на 30 жовтня 2026 року. Вирішальне значення має версія німецькою мовою.'
};
